import React from 'react';
import './App.css';
import './css/style.css';
import './css/layout.css';


import { BrowserRouter as Router, HashRouter, Route, Routes, Outlet } from 'react-router-dom';
import {Helmet} from 'react-helmet';

import Home from './pages/Home';
import TermsAndConditions from './pages/TermsAndConditions';
import LoginPage from './auth/LoginPage/LoginPage';

import Processes from './pages/Processes';
import Process from './pages/Process';

import Step from './pages/Step';


import Artefacts from './pages/Artefacts';
import Artefact from './pages/Artefact';

import Resources from './pages/Resources';
import Resource from './pages/Resource';


import ConceptModels from './pages/ConceptModels';
import ConceptModel from './pages/ConceptModel';
import Concept from './pages/Concept';
import Link from './pages/Link';


import LogicalModels from './pages/LogicalModels';
import LogicalModel from './pages/LogicalModel';
import Entity from './pages/Entity';
import Relationship from './pages/Relationship';


import DataDictionaries from './pages/DataDictionaries';
import DataDictionary from './pages/DataDictionary';
import Structure from './pages/Structure';
import Enumeration from './pages/Enumeration';

import CodeLists from './pages/CodeLists';
import CodeList from './pages/CodeList';
import Item from './pages/Item';


import DataSpecs from './pages/DataSpecs';
import DataSpec from './pages/DataSpec';
import Class from './pages/Class';
import Serialization from './pages/Serialization';

import Interfaces from './pages/Interfaces';
import Interface from './pages/Interface';
import Parameter from './pages/Parameter';
import Method from './pages/Method';



import Solutions from './pages/Solutions';
import Solution from './pages/Solution';
import System from './pages/System';
import Role from './pages/Role';
import Capability from './pages/Capability';
import Participation from './pages/Participation';

import Designs from './pages/Designs';
import Design from './pages/Design';
import DesignItem from './pages/DesignItem';




import Narratives from './pages/Narratives';
import Narrative from './pages/Narrative';



import Viewer from './pages/Viewer';

import DesignerContainer from "./layout/DesignerLayout";
import PublishContainer from "./layout/PublishLayout";
import ScrollToTop from "./components/ScrollToTop";


window.Preferences = {
  style:'pd',
  endpoint:'internal'  
};

//window.data = {};


window.Breadcrumb = [];

//window.TopBanner = null;


class App extends React.Component {

  constructor(props) {
      super(props);

      this.state = {
      };
  };


  setMeta(){
    switch (window.Preferences.style){
      case 'pd':
      default:
        return (

          <Helmet>
            <meta charSet="utf-8" />
            <title>Digital Service Designer</title>
            {/* css now imported directly so that the href does not rely on relative paths */}
            {/* <link rel="stylesheet" type="text/css" href="./style/pd/style.css" /> */}
            {/* <link rel="stylesheet" type="text/css" href="./style/pd/layout.css" /> */}
          </Helmet>
        )
    };
  };

  render() {
// HashRouter changed to Router so that the # can be used to navigate witnin a page
    return(

      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {this.setMeta()}
        <ScrollToTop />
        
        <Routes>

            <Route path="viewer" element={<RoutePublisher/>}>
              <Route path="process/:idTopProcess" element={<Viewer/>}/>
            </Route>


            <Route element={<RouteDesigner/>}>
              <Route exact path="/login" element={<LoginPage />} />

              <Route exact path="processes" element={<Processes/>}/>
              <Route exact path="process" element={<Process/>}/>
              <Route exact path="process/:id" element={<Process/>}/>

              <Route exact path="process/:id/version/:idVersion" element={<Process/>}/>


              <Route exact path="process/:idProcess/step" element={<Step/>}/>
              <Route exact path="step/:id" element={<Step/>}/>


              <Route exact path="artefacts" element={<Artefacts/>}/>
              <Route exact path="artefact" element={<Artefact/>}/>
              <Route exact path="artefact/:id" element={<Artefact/>}/>

              <Route exact path="resources" element={<Resources/>}/>
              <Route exact path="resource" element={<Resource/>}/>
              <Route exact path="resource/:id" element={<Resource/>}/>

              <Route exact path="conceptmodels" element={<ConceptModels/>}/>
              <Route exact path="conceptmodel" element={<ConceptModel/>}/>
              <Route exact path="conceptmodel/:id" element={<ConceptModel/>}/>
              <Route exact path="conceptmodel/:id/version/:idVersion" element={<ConceptModel/>}/>



              <Route exact path="conceptmodel/:idConceptModel/concept" element={<Concept/>}/>
              <Route exact path="concept/:id" element={<Concept/>}/>

              <Route exact path="conceptmodel/:idConceptModel/link" element={<Link/>}/>
              <Route exact path="link/:id" element={<Link/>}/>



              <Route exact path="logicalmodels" element={<LogicalModels/>}/>
              <Route exact path="logicalmodel" element={<LogicalModel/>}/>
              <Route exact path="logicalmodel/:id" element={<LogicalModel/>}/>
              <Route exact path="logicalmodel/:id/version/:idVersion" element={<LogicalModel/>}/>


              <Route exact path="logicalmodel/:idLogicalModel/entity" element={<Entity/>}/>
              <Route exact path="entity/:id" element={<Entity/>}/>

              <Route exact path="logicalmodel/:idLogicalModel/relationship" element={<Relationship/>}/>
              <Route exact path="relationship/:id" element={<Relationship/>}/>


              <Route exact path="datadictionaries" element={<DataDictionaries/>}/>
              <Route exact path="datadictionary" element={<DataDictionary/>}/>
              <Route exact path="datadictionary/:id" element={<DataDictionary/>}/>
              <Route exact path="datadictionary/:id/version/:idVersion" element={<DataDictionary/>}/>

              <Route exact path="codelists" element={<CodeLists/>}/>
              <Route exact path="codelist" element={<CodeList/>}/>
              <Route exact path="codelist/:id" element={<CodeList/>}/>
              <Route exact path="codelist/:id/version/:idVersion" element={<CodeList/>}/>


              <Route exact path="codelist/:idCodeList/item" element={<Item/>}/>
              <Route exact path="item/:id" element={<Item/>}/>


              <Route exact path="datadictionary/:idDataDictionary/structure" element={<Structure/>}/>
              <Route exact path="structure/:id" element={<Structure/>}/>

              <Route exact path="datadictionary/:idDataDictionary/enumeration" element={<Enumeration/>}/>
              <Route exact path="enumeration/:id" element={<Enumeration/>}/>


              <Route exact path="dataspecs" element={<DataSpecs/>}/>
              <Route exact path="dataspec" element={<DataSpec/>}/>
              <Route exact path="dataspec/:id" element={<DataSpec/>}/>
              <Route exact path="dataspec/:idDataSpec/class" element={<Class/>}/>
              <Route exact path="class/:id" element={<Class/>}/>
              <Route exact path="dataspec/:idDataSpec/serialization" element={<Serialization/>}/>
              <Route exact path="serialization/:id" element={<Serialization/>}/>
              <Route exact path="dataspec/:id/version/:idVersion" element={<DataSpec/>}/>


              <Route exact path="interfaces" element={<Interfaces/>}/>

              <Route exact path="interface" element={<Interface/>}/>
              <Route exact path="interface/:id" element={<Interface/>}/>

              <Route exact path="interface/:idInterface/parameter" element={<Parameter/>}/>
              <Route exact path="parameter/:id" element={<Parameter/>}/>


              <Route exact path="interface/:idInterface/method" element={<Method/>}/>
              <Route exact path="method/:id" element={<Method/>}/>

              <Route exact path="interface/:id/version/:idVersion" element={<Interface/>}/>

              <Route exact path="solutions" element={<Solutions/>}/>
              <Route exact path="solution" element={<Solution/>}/>
              <Route exact path="solution/:id" element={<Solution/>}/>
              <Route exact path="solution/:id/version/:idVersion" element={<Solution/>}/>

              <Route exact path="solution/:idSolution/role" element={<Role/>}/>
              <Route exact path="role/:id" element={<Role/>}/>

              <Route exact path="solution/:idSolution/system" element={<System/>}/>
              <Route exact path="system/:id" element={<System/>}/>

              <Route exact path="solution/:idSolution/capability" element={<Capability/>}/>
              <Route exact path="capability/:id" element={<Capability/>}/>

              <Route exact path="solution/:idSolution/participation" element={<Participation/>}/>
              <Route exact path="participation/:id" element={<Participation/>}/>

              <Route exact path="designs" element={<Designs/>}/>
              <Route exact path="design" element={<Design/>}/>
              <Route exact path="design/:id" element={<Design/>}/>
              <Route exact path="design/:id/version/:idVersion" element={<Design/>}/>

              <Route exact path="design/:idDesign/designitem" element={<DesignItem/>}/>
              <Route exact path="designitem/:id" element={<DesignItem/>}/>


              <Route exact path="narratives" element={<Narratives/>}/>

              <Route exact path="narrative" element={<Narrative/>}/>
              <Route exact path="narrative/:id" element={<Narrative/>}/>

              <Route exact path="narrative/:id/version/:idVersion" element={<Narrative/>}/>

              <Route exact path="terms" element={<TermsAndConditions/>}/>
              <Route exact path="terms/:version" element={<TermsAndConditions/>}/>


              <Route path='*' element={<Home/>}/>
            </Route>

        </Routes>
            
      </Router>

    )
  }


}


class RouteDesigner extends React.Component {

  constructor(props) {
      super(props);

      this.state = {
      };
  };


  render(){
    return(
        <DesignerContainer>
          <Outlet/>
        </DesignerContainer>
    )

  }
};


class RoutePublisher extends React.Component {

  constructor(props) {
      super(props);

      this.state = {
      };
  };


  render(){
    return(
        <PublishContainer>
          <Outlet/>
        </PublishContainer>
    )

  }
};





export default App;
